import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { publishMenuSet } from 'src/api/publishMenuSet/publishMenuSet';
import { IPublishMenuSetRequestBody, IPublishMenuSetResponseBody } from 'src/api/publishMenuSet/types';

type Options = Omit<
  UseMutationOptions<IPublishMenuSetResponseBody, unknown, IPublishMenuSetRequestBody, unknown>,
  'mutationFn'
>;

export const usePublishMenuSet = (menuSetId: string, options: Options = {}) => {
  return useMutation((payload: IPublishMenuSetRequestBody) => publishMenuSet(menuSetId, payload), options);
};
